import React, { useState ,useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/Common.module.css';
import Button from '../../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoMdClose,IoLogoWhatsapp,IoIosMail} from "react-icons/io";
import {getAlumnisAllata,PostAlumnisAllata,getCountryListFormData,getStateListByCountryId,getCityListByStateId} from '../../../services/routes.services'
import constants from '../../../services/constants'
import PlaceholderImage from '../../../assest/images/list-img01.png';  // Add a placeholder image
import LoginPopup from "../../Common/Login/UserLogin";
import { useSelector } from 'react-redux';
import Pagination from "../Pagination";

const AlumniDirectoryPage = ()=>{
    const [alumniPopup, setAlumniPopup] = useState(false);
    const [alumniPopupData, setAlumniPopupData] = useState('');
    const [alumnidata, setAlumniData] = useState([]);
     const [latestAlumnidata, setLatestAlumniData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [batchFilter, setBatchFilter] = useState('');
    const [schoolFilter, setSchoolFilter] = useState('');
    const [countryFilter, setCountryFilter] = useState('');
    const [stateFilter, setStateFilter] = useState('');
    const [cityFilter, setCityFilter] = useState('');
    const [professionFilter, setProfessionFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [schoolOptions, setSchoolOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [professionOptions, setProfessionOptions] = useState([]);
    // pagination
  
     const [itemsPerPage, setItemsPerPage] = useState(10); // State for items per page
    //Login Popup
    const [loginShow, setLoginShow] = useState(false);
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const loginCloseHandler = ()=>{
            setLoginShow(false)
    }
    useEffect(()=>{
        if(isAuthenticated === false){
            setLoginShow(true)
        }
    }, []);
    useEffect(() => {
        getAlumnisAllata()
            .then((res) => {
                const alumni = res.data.alumni;
                setAlumniData(alumni);
                const uniqueBatches = new Set(alumni.map(alumnus => alumnus.batch).filter(batch => batch !== "null" && batch !== "").filter(Boolean));
                const lastestAlumni =res.data.latestAlumni;
                setLatestAlumniData(lastestAlumni);
                setTotalItems(res.data.totalItems);
                setTotalPages(res.data.totalPages);
               
                const uniqueSchools = new Set(alumni.map(alumnus => alumnus.school).filter(school => school !== "null" && school !== "").filter(Boolean));
                const uniqueProfessions = res.data.category;


                // Set state for unique schools and sort professions alphabetically
                setSchoolOptions([...uniqueSchools]);
                const sortedData = uniqueProfessions.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

                setProfessionOptions(sortedData);
          })
            .catch((error) => {
                console.log(error);
            });
            getCountryListFormData()
            .then((res) => {
              const  dataCountry=res.data.countries;
                setCountryOptions(dataCountry);
               
            })
            .catch((error) => {
                console.log(error);
            });
            
    }, []);
   
    const fetchAlumni = async (currentPage,professionfilter,cityfilter,statefilter,countryfilter,batchfilter,searchkeyfilter,schoolfilter,PerPagefilter) => {
        try {
            
            const data = new URLSearchParams();

            data.append("country", countryfilter || "");
            data.append("state", statefilter || "");
            data.append("city", cityfilter || "");
            data.append("profession", professionfilter || "");
            data.append("batch", batchfilter || "");
            data.append("school", schoolfilter || "");
            data.append("search", searchkeyfilter || "");
            data.append("page", currentPage || "");
            data.append("perPage",PerPagefilter|| ""); // Add your desired default value or logic here
        
          const response =await PostAlumnisAllata("paginate",data.toString())
        
    let result= response.data;
 
          if (result.success) {
            setAlumniData(result.alumni ); // Ensure alumni is updated
            setTotalItems(result.totalItems);
            setTotalPages(result.totalPages);
            setCurrentPage(result.page);
          } else {
            console.error("Failed to fetch alumni data:", result);
          }
        } catch (error) {
          console.error("Error fetching alumni data:", error);
        }
      };
      let professionfilter= localStorage.getItem('profession')
      let cityfilters =localStorage.getItem('City')
      let statefilters=localStorage.getItem('State')
      let countryfilters=localStorage.getItem('Country')
      let searchkeyfilter=localStorage.getItem('searchKey')
      let schoolfilter=localStorage.getItem('School')
      let batchfilter = localStorage.getItem('Batch')
      let PerPagefilter = localStorage.getItem('PerPage')
     
      useEffect(() => {
        fetchAlumni(currentPage,professionfilter,cityfilters,statefilters,countryfilters,batchfilter,searchkeyfilter,schoolfilter,PerPagefilter); // Fetch alumni data on initial load
      }, [currentPage,professionfilter,cityfilters,statefilters,countryfilters,batchfilter,searchkeyfilter,schoolfilter,PerPagefilter]);
    
      const handlePageChange = (page) => {
        // alert(page)
        setCurrentPage(page)
        fetchAlumni(page,professionfilter,cityfilters,statefilters,countryfilters,batchfilter,searchkeyfilter,schoolfilter,PerPagefilter,); // Fetch data when pagination is clicked
      };
   
    const shoeAlumniHandler=(alumnusData)=>{
        setAlumniPopup(true)
        setAlumniPopupData(alumnusData)
    }
    const closeAlumniHandler = ()=>{
        setAlumniPopup(false)
    }
    const lastSixAlumnis = latestAlumnidata.length > 0 ? latestAlumnidata.slice(-6) : [];
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        localStorage.setItem('searchKey', e.target.value);
    };

    const handleBatchChange = (e) => {
        localStorage.setItem('Batch', e.target.value)
        setBatchFilter(e.target.value);
    };

    const handleSchoolChange = (e) => {
        localStorage.setItem('School', e.target.value)
        setSchoolFilter(e.target.value);
    };

    const handleCountryChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
         const countryCode = selectedOption.getAttribute('data-code'); // Custom data attribute

        const selectedCountry = e.target.value;
        setCityOptions([])
        
         // Fetch states based on selected country
         if(selectedCountry!==''){
            getStateListByCountryId(selectedCountry)
        .then((res) => {
            const dataState=res.data;
            setStateOptions(dataState);
         
           
        })
        .catch((error) => {
            console.log(error);
        });
    }
    localStorage.setItem('Country', countryCode)
        setCountryFilter(selectedCountry);
    };

    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        if(selectedState!==''){
        // Fetch cities based on selected state
        getCityListByStateId(selectedState)
        .then((res) => {
            const dataCity=res.data;
            setCityOptions(dataCity);
        })
        .catch((error) => {
            console.log(error);
        });
    }
    const selectedOption = e.target.options[e.target.selectedIndex];
    const stateCode = selectedOption.getAttribute('data-code'); // Custom data attribute

    localStorage.setItem('State', stateCode)
        setStateFilter(e.target.value);
    };

    const handleCityChange = (e) => {
        setCityFilter(e.target.value);
        const selectedOption = e.target.options[e.target.selectedIndex];
    const cityCode = selectedOption.getAttribute('data-code'); // Custom data attribute

        localStorage.setItem('City', cityCode)
    };

    const handleProfessionChange = (e) => {
        localStorage.setItem('profession', e.target.value)
        setProfessionFilter(e.target.value);
    };

   
    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
          setItemsPerPage(parseInt(e.target.value, 10));
          localStorage.setItem('PerPage', e.target.value)
        setCurrentPage(1); // Reset to first page when changing items per page
    };
  //Handle reset filter
  const handleResetfilter=()=>{
    
    setBatchFilter('');
    setSchoolFilter('');
    setCountryFilter('');
    setStateFilter('');
    setCityFilter('');
    setProfessionFilter('');
    localStorage.setItem('City', "")
    localStorage.setItem('profession', "")
    localStorage.setItem('Batch', "")
    localStorage.setItem('School', "")
    localStorage.setItem('Country', "")
    localStorage.setItem('State', "")
    localStorage.setItem('PerPage', "")
    localStorage.setItem('searchKey', "");
    fetchAlumni(currentPage,professionfilter,cityfilters,statefilters,countryfilters,batchfilter,searchkeyfilter,schoolfilter)
  }
  const currentYear = new Date().getFullYear();
  const batchOptions = Array.from({ length: currentYear - 1950 + 1 }, (_, i) => 1950 + i);
  
    return(
        <div className="loginView">
             {isAuthenticated ? 
             <div>
                <section className={Style.clear + " "+Style.breadcrumb}>
                    <Container>
                    <Row>
                        <Col>
                            <ul>
                                <li><Link to="/">Home </Link></li>
                                <li><Link to='/community'>Community</Link></li>
                                <li>Alumni Directory</li>
                            </ul>
                        </Col>
                    </Row>
                    </Container>
                </section>
            
                <div className={Style.pageTitle + ' ' + Style.marginUp90}>
                    <Container>
                        <Row>
                            <Col>
                                <div className={Style.sectionTitle}>
                                    <h2>Alumni Directory</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.pageSubTitle}>
                                    <h3>NEW MEMBERS</h3>
                                    <ul className={Style.newlisting}>
                                        {alumnidata !==''?(
                                            <>{lastSixAlumnis.map((alumanis)=>{
                                                return(
                                                <li key={alumanis._id} onClick={()=>shoeAlumniHandler(alumanis)}>
                                                    {console.log(alumanis?.image,"imgggg")}
                                                <figure><img   src={ alumanis?.image!=='null' ? `${constants.IMAGE_BASE_URL}alumni/${alumanis.image}` : PlaceholderImage} alt={alumanis?.name}/></figure>
                                                <h3>{alumanis?.name} {alumanis?.last}</h3>
                                                <h5>Batch {alumanis?.batch}</h5>
                                                </li>
                                                )
                                            })}</>
                                            
                                        ):null}
                                    
                                    
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={Style.searchArea}>
                                <div className={Style.searchContainer}>
                                    <div className={Style.searchInput}>
                                        <input type="text"  placeholder="Search by name, last name, or email" value={searchTerm} onChange={handleSearchChange}/>
                                        <button type="button">Search</button>
                                    </div>
                                    <div className={Style.byYear}>
                                    <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                                    <option  value="10">Page Size</option>
                                            <option value="20">Show 20</option>
                                            <option value="50">Show 50</option>
                                            <option value="100">Show 100</option>
                                        </select>
                                    
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={Style.elementPadding80}>
                                    <Row>
                                        <Col md={2}>
                                            <div className={Style.FliterSection}>
                                                <div className={Style.filterHead}>
                                                    {/* <h6><FaFilter /> Filter</h6> */}
                                                    <button type="button" onClick={()=>handleResetfilter()}>Reset</button>
                                                </div>
                                                <div className={Style.filterSelect}>
                                                <select value={batchFilter} onChange={handleBatchChange}>
                                                        <option value="">Select Batch</option>
                                                        {batchOptions.map(option => (
                                                            <option key={option} value={option}>{option}</option>
                                                        ))}
                                                    </select>
                                                    <select value={schoolFilter} onChange={handleSchoolChange}>
                                                        <option value="">Select School</option>
                                                        {/* {schoolOptions.map(option => ( */}
                                                            <option value="Mayo Boys">Mayo Boys</option>
                                                            <option  value="Mayo Girls">Mayo Girls</option>
                                                        {/* ))} */}
                                                    </select>
                                                    <select value={countryFilter} onChange={(e)=>handleCountryChange(e)}>
                                                         <option value="">Select Country</option>
                                                    
                                                        {countryOptions && countryOptions.map(country => (
                                                            <option key={country.id} value={country.id} data-code={country._id}>{country.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={stateFilter} onChange={(e)=>handleStateChange(e)}>
                                                        <option value="">Select State</option>
                                                    
                                                        {stateOptions && stateOptions.map(state => (
                                                            <option key={state.id} data-code={state._id} value={state.id}>{state.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={cityFilter} onChange={(e)=>handleCityChange(e)}>
                                                        <option value="">Select City</option>
                                                    
                                                        {cityOptions.map(city => (
                                                            <option key={city.id} data-code={city._id} value={city.id}>{city.name}</option>
                                                        ))}
                                                    </select>
                                                    <select value={professionFilter} onChange={handleProfessionChange}>
                                                        <option value="">Select Profession</option>
                                                       {console.log(professionOptions)}
                                                        {professionOptions.map(option => (
                                                            <option key={option._id} value={option._id}>{option.name}</option>
                                                        ))}
                                                    </select>
                                                    
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={10}>
                                        
                                        {alumnidata &&
                                            <Row>
                                                {alumnidata.map(alumnus => (
                                                    <Col md={6} key={alumnus._id}>
                                                        <div className={Style.AlumniMember} onClick={()=>shoeAlumniHandler(alumnus)}>
                                                        <figure>
                                                        <img src={alumnus.image !=='null' ? `${constants.IMAGE_BASE_URL}alumni/${alumnus.image}` : PlaceholderImage} alt={`${alumnus.name} ${alumnus.last}`} />
                                                        
                                                        </figure>
                                                        
                                                        <div className={Style.AlumniDetail}>
                                                            <h3 onClick={()=>shoeAlumniHandler(alumnus)}>{alumnus.name} {alumnus.last}</h3>
                                                            <ul>
                                                            <li>Batch: {alumnus.batch ? <span>{alumnus.batch || 'N/A'}</span> : 'N/A'}</li>
                                                            <li>City: {alumnus.city ? <span>{alumnus.city.name || 'N/A'}</span> : 'N/A'}</li>
                                                            <li>School: {alumnus.school ? <span>{alumnus.school || 'N/A'}</span> : 'N/A'}</li>
                                                        </ul>
                                                        </div>
                                                        </div>
                                                    </Col>
                                                    ))}
                                                    <div>
                                                    {alumniPopup &&
                                                            <div className={Style.overlay}>
                                                                <div className={Style.poupContainer}>
                                                                    <button onClick={closeAlumniHandler} className={Style.closePop}><IoMdClose /></button>
                                                                   
                                                                    <div className={Style.memberDetailContainer}>
                                                                    <figure>
                                                                        <img
                                                                            src={alumniPopupData?.image !=='null' ? `${constants.IMAGE_BASE_URL}alumni/${alumniPopupData.image}` : PlaceholderImage}
                                                                            alt={`${alumniPopupData?.name || ''} ${alumniPopupData?.last || ''}`}
                                                                        />
                                                                    </figure>
                                                                    <div className={Style.memberDetailElement}>
                                                                        <h3>{alumniPopupData?.name} {alumniPopupData?.last}</h3>

                                                                        <table>
                                                                            {alumniPopupData?.batch !== "null" && (
                                                                                <tr>
                                                                                    <td>Batch</td>
                                                                                    <td>{alumniPopupData.batch}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.email !== "null" && (
                                                                                <tr>
                                                                                    <td>Email</td>
                                                                                    <td>{alumniPopupData.email}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.phone !== "null" && (
                                                                                <tr>
                                                                                    <td>Phone</td>
                                                                                    <td>{alumniPopupData.phone}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.city?.name && (
                                                                                <tr>
                                                                                    <td>City</td>
                                                                                    <td>{alumniPopupData.city.name}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.country?.name && (
                                                                                <tr>
                                                                                    <td>Country</td>
                                                                                    <td>{alumniPopupData.country.name}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.designation !== "null" && (
                                                                                <tr>
                                                                                    <td>Designation</td>
                                                                                    <td>{alumniPopupData.designation}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.orgname !== "null" && (
                                                                                <tr>
                                                                                    <td>Organization Name</td>
                                                                                    <td>{alumniPopupData.orgname}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.rollno !== "null" && (
                                                                                <tr>
                                                                                    <td>Roll No.</td>
                                                                                    <td>{alumniPopupData.rollno}</td>
                                                                                </tr>
                                                                            )}
                                                                            {alumniPopupData?.houseinmayo !== "null" && (
                                                                                <tr>
                                                                                    <td>House</td>
                                                                                    <td>{alumniPopupData.houseinmayo}</td>
                                                                                </tr>
                                                                            )}
                                                                        </table>

                                                                        <div className={Style.alignRight}>
                                                                            {alumniPopupData?.email && alumniPopupData.email !== "null" && (
                                                                                <a href={`mailto:${alumniPopupData.email}`}>
                                                                                    <IoIosMail className={Button.goBlueBtn} />
                                                                                </a>
                                                                            )}
                                                                            {alumniPopupData?.phone && alumniPopupData?.country?.iso2 && (
                                                                                <a href={`https://wa.me/${alumniPopupData.country.iso2}${alumniPopupData.phone}`} target="_blank">
                                                                                    <IoLogoWhatsapp className={Button.goGreenBtn} />
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                               
                                            </Row>
                                        }
                                            <Row>
                                                {console.log(totalItems,"totalItems",currentPage,"currentPage",totalPages,"totalPages")}
                                                <Col md={12}>
                                                <Pagination
                                                totalItems={totalItems}
                                                page={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={handlePageChange}
                                            />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            : loginShow && <LoginPopup onClose={loginCloseHandler} /> }
        </div>
    )
}

export default AlumniDirectoryPage;